import { Route } from 'react-router-dom';
import { SittingSchedulesRoute } from './schedules/route';

export const SittingRoute = <Route path="sitting">{SittingSchedulesRoute}</Route>;
